import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const QualityAssurance = () => {
  return (
    <>
      <SEO 
        title="Quality Assurance & Testing Services - Abacies Logiciels"
        description="Ensure software quality with comprehensive QA and testing services. Abacies provides automated testing, manual testing, performance testing, and security testing to deliver reliable, bug-free applications."
        keywords="quality assurance, QA testing, software testing, automated testing, performance testing, security testing, test automation"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Quality Assurance
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Quality Assurance page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Quality Assurance. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default QualityAssurance;
